import React, { Component } from "react";
import { Grid, Row, Col, Table } from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import { WEB_URL } from "variables/Variables.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import ProgressButton from "components/ProgressButton/ProgressButton.jsx";

class Invoices extends Component {
  constructor(props) {
    super(props);

    this.state = {
      invoiceList : null,
      NewCompanyName : '',
      NewBillingName : '',
      NewAddress : '',
      NewCity : '',
      NewState : '',
      NewZip : '',
      NewCountry : '',
      NewTaxID : ''
    }
  }

  componentDidMount () {
    fetch("https://"+WEB_URL+"/account/api/getinvoicelist",{
      'method' : 'POST',
      'headers' : { 'Content-Type' : 'application/json'},
      'body' : JSON.stringify({'token':this.props.authDetail.token})
    }).then(res => res.json())
      .then(
        (response) => {
          if(response.invoicedetails.CompanyName){
            this.setState({NewCompanyName : response.invoicedetails.CompanyName});
          }
          if(response.invoicedetails.BillingName){
            this.setState({NewBillingName : response.invoicedetails.BillingName});
          }
          if(response.invoicedetails.BillingAddress){
            this.setState({NewAddress : response.invoicedetails.BillingAddress});
          }
          if(response.invoicedetails.BillingCity){
            this.setState({NewCity : response.invoicedetails.BillingCity});
          }
          if(response.invoicedetails.BillingState){
            this.setState({NewState : response.invoicedetails.BillingState});
          }
          if(response.invoicedetails.BillingZip){
            this.setState({NewZip : response.invoicedetails.BillingZip});
          }
          if(response.invoicedetails.BillingCountry){
            this.setState({NewCountry : response.invoicedetails.BillingCountry});
          }
          if(response.invoicedetails.TaxID){
            this.setState({NewTaxID : response.invoicedetails.TaxID});
          }

          var il = [];
          for(var p=0;p<response.invoices.length;p++){
            il.push(response.invoices[p]);
          }
          this.setState({invoiceList : il})
        },
        (error) => {
          
        }
      )
  }

  downloadInvoice(invoice,e){

    if(!this.state.NewCompanyName && !this.state.NewBillingName){this.props.triggerNotification('error','tc','Please update your name/company name before downloading the invoice');return;}
    if(!this.state.NewAddress){this.props.triggerNotification('error','tc','Please update your address before downloading the invoice');return;}
    if(!this.state.NewZip){this.props.triggerNotification('error','tc','Please update your zip code before downloading the invoice');return;}
    if(!this.state.NewTaxID){this.props.triggerNotification('error','tc','Please update your Tax ID before downloading the invoice');return;}
    
    // when rendering off the flowpaper service, we render them in base64 format
    // so we just need to fetch it first
    if(invoice.pdf.indexOf('http')!=0){ 
      fetch("https://"+WEB_URL+invoice.pdf,{
        'method' : 'POST',
        'headers' : { 'Content-Type' : 'application/json'},
        'body' : JSON.stringify({
          'txn_id' : invoice.id,
          'action' : 'getpdfinvoice',
          'token':this.props.authDetail.token
        })
      }).then(res => res.json())
      .then(
        (response) => {
          var link = document.createElement("a");
          link.download = 'Invoice.pdf';
          link.href = 'data:application/pdf;base64,' + response.pdf;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
        (error) => {
        
        }
      )
    }else{ // otherwise we'll just point straight to the PDF file (for Stripe's PDFs for example)
      var link = document.createElement("a");
      link.download = invoice.pdf;
      link.href = invoice.pdf;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);  
    }

    e.preventDefault();
    return false;
  }

  handleUpdateBillingDetails(e){
    this.setState({ runningUpdateBillingOperation : true});
    var _this = this;
    
    fetch("https://"+WEB_URL+"/account/api/getinvoicelist",{
      'method' : 'POST',
      'headers' : { 'Content-Type' : 'application/json'},
      'body' : JSON.stringify({ 'token' : this.props.authDetail.token, 
                                'action' : 'updateinvoicedetails',

                                'NewCompanyName'  : this.state.NewCompanyName,
                                'NewBillingName'  : this.state.NewBillingName,
                                'NewAddress'      : this.state.NewAddress,
                                'NewCity'         : this.state.NewCity, 
                                'NewState'        : this.state.NewState,
                                'NewZip'          : this.state.NewZip,
                                'NewCountry'      : this.state.NewCountry,
                                'NewTaxID'        : this.state.NewTaxID
                              })
    }).then(res => res.json())
      .then(
        (response) => {
          this.setState({ runningUpdateBillingOperation : false});
          if(response.result == 'SUCCESS'){
            _this.props.authDetail.detail.TaxID          = _this.state.NewTaxID;
            _this.props.authDetail.detail.BillingCountry = _this.state.NewCountry;

            this.props.triggerNotification('success','tc',response.message);
          }else{
            this.props.triggerNotification('error','tc',response.message);  
          }
        },
        (error) => {
          this.setState({ runningUpdateBillingOperation : true});

        }
      )
  }

  handleUserInput (e) {
    const name = e.target.name;
    const value = e.target.value;

    this.setState({[name]: value});
  }

  render() {
    return (
      <div className="content">
        

        {this.state.invoiceList!=null ? 
        <div>
          <Grid fluid>
            <Row>
              <Col md={8}>
              <Row>
                <Col md={12}>
                  <Card
                    title="Invoice Details"
                    content={
                      <form>
                          <FormInputs
                            ncols={["col-md-6", "col-md-6"]}
                            properties={[
                              {
                                label: "Company Name",
                                name: "NewCompanyName",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Company Name",
                                defaultValue: this.state.NewCompanyName
                              },
                              {
                                label: "Name",
                                name: "NewBillingName",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Name",
                                defaultValue: this.state.NewBillingName
                              }
                            ]}
                            onChange={(event) => this.handleUserInput(event)} 
                          />

                          <FormInputs
                            ncols={["col-md-6", "col-md-6"]}
                            properties={[
                              {
                                label: "Address",
                                name: "NewAddress",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Address",
                                defaultValue: this.state.NewAddress
                              },
                              {
                                label: "City",
                                name: "NewCity",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "City",
                                defaultValue: this.state.NewCity
                              }
                            ]}
                            onChange={(event) => this.handleUserInput(event)} 
                          />

                          <FormInputs
                            ncols={["col-md-6", "col-md-6"]}
                            properties={[
                              {
                                label: "State/Province",
                                name: "NewState",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "State",
                                defaultValue: this.state.NewState
                              },
                              {
                                label: "Zip/Postal",
                                name: "NewZip",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Zip",
                                defaultValue: this.state.NewZip
                              }
                            ]}
                            onChange={(event) => this.handleUserInput(event)} 
                          />

                          <FormInputs
                            ncols={["col-md-6", "col-md-6"]}
                            properties={[
                              {
                                label: "Country",
                                name: "NewCountry",
                                componentClass: "select",
                                options: [{"value":"Afghanistan"},{"value":"Albania"},{"value":"Algeria"},{"value":"American Samoa"},{"value":"Andorra"},{"value":"Angola"},{"value":"Anguilla"},{"value":"Antarctica"},{"value":"Antigua and Barbuda"},{"value":"Argentina"},{"value":"Armenia"},{"value":"Aruba"},{"value":"Australia"},{"value":"Austria"},{"value":"Azerbaijan"},{"value":"Bahamas"},{"value":"Bahrain"},{"value":"Bangladesh"},{"value":"Barbados"},{"value":"Belarus"},{"value":"Belgium"},{"value":"Belize"},{"value":"Benin"},{"value":"Bermuda"},{"value":"Bhutan"},{"value":"Bolivia"},{"value":"Bosnia and Herzegowina"},{"value":"Botswana"},{"value":"Bouvet Island"},{"value":"Brazil"},{"value":"British Indian Ocean Territory"},{"value":"Brunei Darussalam"},{"value":"Bulgaria"},{"value":"Burkina Faso"},{"value":"Burundi"},{"value":"Cambodia"},{"value":"Cameroon"},{"value":"Canada"},{"value":"Cape Verde"},{"value":"Cayman Islands"},{"value":"Central African Republic"},{"value":"Chad"},{"value":"Chile"},{"value":"China"},{"value":"Christmas Island"},{"value":"Cocos (Keeling) Islands"},{"value":"Colombia"},{"value":"Comoros"},{"value":"Congo"},{"value":"Congo, the Democratic Republic of the"},{"value":"Cook Islands"},{"value":"Costa Rica"},{"value":"Cote d'Ivoire"},{"value":"Croatia (Hrvatska)"},{"value":"Cuba"},{"value":"Cyprus"},{"value":"Czech Republic"},{"value":"Denmark"},{"value":"Djibouti"},{"value":"Dominica"},{"value":"Dominican Republic"},{"value":"East Timor"},{"value":"Ecuador"},{"value":"Egypt"},{"value":"El Salvador"},{"value":"Equatorial Guinea"},{"value":"Eritrea"},{"value":"Estonia"},{"value":"Ethiopia"},{"value":"Falkland Islands (Malvinas)"},{"value":"Faroe Islands"},{"value":"Fiji"},{"value":"Finland"},{"value":"France"},{"value":"France, Metropolitan"},{"value":"French Guiana"},{"value":"French Polynesia"},{"value":"French Southern Territories"},{"value":"Gabon"},{"value":"Gambia"},{"value":"Georgia"},{"value":"Germany"},{"value":"Ghana"},{"value":"Gibraltar"},{"value":"Greece"},{"value":"Greenland"},{"value":"Grenada"},{"value":"Guadeloupe"},{"value":"Guam"},{"value":"Guatemala"},{"value":"Guinea"},{"value":"Guinea-Bissau"},{"value":"Guyana"},{"value":"Haiti"},{"value":"Heard and Mc Donald Islands"},{"value":"Holy See (Vatican City State)"},{"value":"Honduras"},{"value":"Hong Kong"},{"value":"Hungary"},{"value":"Iceland"},{"value":"India"},{"value":"Indonesia"},{"value":"Iran (Islamic Republic of)"},{"value":"Iraq"},{"value":"Ireland"},{"value":"Israel"},{"value":"Italy"},{"value":"Jamaica"},{"value":"Japan"},{"value":"Jordan"},{"value":"Kazakhstan"},{"value":"Kenya"},{"value":"Kiribati"},{"value":"Korea, Democratic People's Republic of"},{"value":"Korea, Republic of"},{"value":"Kuwait"},{"value":"Kyrgyzstan"},{"value":"Lao People's Democratic Republic"},{"value":"Latvia"},{"value":"Lebanon"},{"value":"Lesotho"},{"value":"Liberia"},{"value":"Libyan Arab Jamahiriya"},{"value":"Liechtenstein"},{"value":"Lithuania"},{"value":"Luxembourg"},{"value":"Macau"},{"value":"Macedonia, The Former Yugoslav Republic of"},{"value":"Madagascar"},{"value":"Malawi"},{"value":"Malaysia"},{"value":"Maldives"},{"value":"Mali"},{"value":"Malta"},{"value":"Marshall Islands"},{"value":"Martinique"},{"value":"Mauritania"},{"value":"Mauritius"},{"value":"Mayotte"},{"value":"Mexico"},{"value":"Micronesia, Federated States of"},{"value":"Moldova, Republic of"},{"value":"Monaco"},{"value":"Mongolia"},{"value":"Montserrat"},{"value":"Morocco"},{"value":"Mozambique"},{"value":"Myanmar"},{"value":"Namibia"},{"value":"Nauru"},{"value":"Nepal"},{"value":"Netherlands"},{"value":"Netherlands Antilles"},{"value":"New Caledonia"},{"value":"New Zealand"},{"value":"Nicaragua"},{"value":"Niger"},{"value":"Nigeria"},{"value":"Niue"},{"value":"Norfolk Island"},{"value":"Northern Mariana Islands"},{"value":"Norway"},{"value":"Oman"},{"value":"Pakistan"},{"value":"Palau"},{"value":"Panama"},{"value":"Papua New Guinea"},{"value":"Paraguay"},{"value":"Peru"},{"value":"Philippines"},{"value":"Pitcairn"},{"value":"Poland"},{"value":"Portugal"},{"value":"Puerto Rico"},{"value":"Qatar"},{"value":"Reunion"},{"value":"Romania"},{"value":"Russian Federation"},{"value":"Rwanda"},{"value":"Saint Kitts and Nevis"},{"value":"Saint LUCIA"},{"value":"Saint Vincent and the Grenadines"},{"value":"Samoa"},{"value":"San Marino"},{"value":"Sao Tome and Principe"},{"value":"Saudi Arabia"},{"value":"Senegal"},{"value":"Seychelles"},{"value":"Sierra Leone"},{"value":"Singapore"},{"value":"Slovakia (Slovak Republic)"},{"value":"Slovenia"},{"value":"Solomon Islands"},{"value":"Somalia"},{"value":"South Africa"},{"value":"South Georgia and the South Sandwich Islands"},{"value":"Spain"},{"value":"Sri Lanka"},{"value":"St. Helena"},{"value":"St. Pierre and Miquelon"},{"value":"Sudan"},{"value":"Suriname"},{"value":"Svalbard and Jan Mayen Islands"},{"value":"Swaziland"},{"value":"Sweden"},{"value":"Switzerland"},{"value":"Syrian Arab Republic"},{"value":"Taiwan, Province of China"},{"value":"Tajikistan"},{"value":"Tanzania, United Republic of"},{"value":"Thailand"},{"value":"Togo"},{"value":"Tokelau"},{"value":"Tonga"},{"value":"Trinidad and Tobago"},{"value":"Tunisia"},{"value":"Turkey"},{"value":"Turkmenistan"},{"value":"Turks and Caicos Islands"},{"value":"Tuvalu"},{"value":"Uganda"},{"value":"Ukraine"},{"value":"United Arab Emirates"},{"value":"United Kingdom"},{"value":"United States"},{"value":"United States Minor Outlying Islands"},{"value":"Uruguay"},{"value":"Uzbekistan"},{"value":"Vanuatu"},{"value":"Venezuela"},{"value":"Viet Nam"},{"value":"Virgin Islands (British)"},{"value":"Virgin Islands (U.S.)"},{"value":"Wallis and Futuna Islands"},{"value":"Western Sahara"},{"value":"Yemen"},{"value":"Yugoslavia"},{"value":"Zambia"},{"value":"Zimbabwe"}],
                                selected: this.state.NewCountry,
                                value: this.state.NewCountry,
                                bsClass: "form-control",
                                defaultValue: this.state.NewCountry
                              },
                              {
                                label: "VAT / Tax ID",
                                name: "NewTaxID",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Tax ID",
                                defaultValue: this.state.NewTaxID
                              }
                            ]}
                            onChange={(event) => this.handleUserInput(event)} 
                          />
                          
                          <ProgressButton runningAsyncOperation={this.state.runningUpdateBillingOperation} bsStyle="info" fill type="submit" onClick={(e) => {this.handleUpdateBillingDetails(e);}}>
                            Update Invoice Details
                          </ProgressButton>

                          <div className="clearfix" />
                        </form>
                      }
                  />
                  </Col>
              </Row>
              </Col>
            </Row>
          </Grid>
          <Grid fluid>
            <Row>
              <Col md={8}>
              {this.state.invoiceList.length ? 
              <Card
                  title="Recent Invoices"
                  category=""
                  ctTableFullWidth
                  ctTableResponsive
                  content={
                    <Table striped hover>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Total</th>
                          <th className="pull-right">&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                      {this.state.invoiceList.map((invoice, index) => {
                        
                          return (
                              <tr key={`${invoice.id}`}>
                                  <td>{invoice.date}</td>
                                  <td>${(Number(invoice.amount)/100).toFixed(2)}</td>
                                  <td><button type="submit" onClick={(e) => this.downloadInvoice(invoice, e)} className="pull-right btn btn-info btn-xs btn-fill" style={{marginRight:10}}>Download</button></td>
                              </tr>
                          );
                      })}
                      </tbody>
                    </Table>
                  }
                />:<Card
                title=""
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div style={{margin:20}}>No invoices available for download</div>
                }/>}
              </Col>
            </Row>
          </Grid>
        </div>
        :<div className="spinner-grow text-primary" role="status">
        <span className="sr-only">Loading...</span>
        </div>}
      </div>
    );
  }
}

export default Invoices;
